import { render, staticRenderFns } from "./OrdersCollapseSupplies.vue?vue&type=template&id=7a6235e2&"
import script from "./OrdersCollapseSupplies.vue?vue&type=script&lang=js&"
export * from "./OrdersCollapseSupplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports